import type { SVGProps } from 'react';

interface BonusesIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const BonusesIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & BonusesIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 14 14"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#bonuses-icon_svg__a)">
      <path
        clipRule="evenodd"
        d="M4.56.453a.875.875 0 1 0-1.12 1.344L4.883 3H2C1.103 3 .375 3.728.375 4.625v2c0 .676.413 1.256 1 1.5v4A1.625 1.625 0 0 0 3 13.75h8a1.625 1.625 0 0 0 1.625-1.625v-4c.587-.244 1-.824 1-1.5v-2C13.625 3.728 12.898 3 12 3H9.117l1.443-1.203A.875.875 0 0 0 9.44.453L7 2.486zM2 4.25h3.875V7H2a.375.375 0 0 1-.375-.375v-2c0-.207.168-.375.375-.375m6.125 0V7H12a.375.375 0 0 0 .375-.375v-2A.375.375 0 0 0 12 4.25zm-5.5 4h3.25v4.25H3a.375.375 0 0 1-.375-.375zm5.5 0v4.25H11a.375.375 0 0 0 .375-.375V8.25z"
        fill="#4FA9FF"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="bonuses-icon_svg__a">
        <path d="M0 0h14v14H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
